var _g, _path, _g2, _g3, _g4, _g5, _g6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndersenSummerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 47,
    viewBox: "0 0 35 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0377 37.7667C19.1201 41.142 17.2197 44.5928 16.2593 45.8963C19.7581 47.4399 22.1249 46.3079 23.154 45.8963C24.1831 45.4847 23.5656 41.4713 23.154 41.3684C23.4627 41.2655 23.2569 36.8405 23.154 35.194C23.0511 33.5475 23.2569 32.3127 22.4337 32.3127C23.4216 30.5015 20.5813 20.993 19.0377 16.4651C18.3174 16.6023 16.7944 16.9385 16.4651 17.1854C17.8029 19.1407 19.0377 26.9615 19.1407 27.9906C19.2436 29.0197 19.5523 28.9168 19.5523 29.0197C19.5523 29.1226 19.2436 29.0197 19.4494 30.0487C19.9433 31.6129 19.518 35.4342 19.2436 37.1493L19.6552 37.458L19.0377 37.7667Z",
    fill: "#AE6240"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0377 37.7667C19.1201 41.142 17.2197 44.5928 16.2593 45.8963C19.7581 47.4399 22.1249 46.3079 23.154 45.8963C24.1831 45.4847 23.5656 41.4713 23.154 41.3684C23.4627 41.2655 23.2569 36.8405 23.154 35.194C23.0511 33.5475 23.2569 32.3127 22.4337 32.3127C23.4216 30.5015 20.5813 20.993 19.0377 16.4651C18.3174 16.6023 16.7944 16.9385 16.4651 17.1854C17.8029 19.1407 19.0377 26.9615 19.1407 27.9906C19.2436 29.0197 19.5523 28.9168 19.5523 29.0197C19.5523 29.1226 19.2436 29.0197 19.4494 30.0487C19.9433 31.6129 19.518 35.4342 19.2436 37.1493L19.6552 37.458L19.0377 37.7667Z",
    stroke: "#81421E",
    strokeWidth: 0.0617438
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8583 16.4892C13.7945 16.4545 14.3335 15.8784 14.8873 15.4835C14.0088 16.0268 13.0137 16.207 12.0131 16.0225C10.9185 15.8206 11.8158 15.0559 12.2458 14.6128L12.2441 14.6139C11.8124 14.9112 11.3457 15.2325 10.9163 15.6751C10.4863 16.1182 9.83477 16.3463 8.45129 16.2943C7.06781 16.2423 7.71279 15.5776 7.9256 15.2105C4.40527 18.2471 5.61265 16.2641 5.89713 15.8232C4.96767 16.9288 4.3205 17.4479 3.01086 17.4676C1.70122 17.4872 0.552431 18.5233 0.684837 17.6481C1.23194 15.3111 4.15724 13.0354 5.5515 12.1897C11.9778 8.8184 17.0406 11.5806 17.9509 14.0412C18.8611 16.5019 16.6959 17.6988 15.7467 17.4947C14.7976 17.2906 15.3015 16.9192 15.6642 16.841C16.0268 16.7627 16.3873 16.539 14.8583 16.4892Z",
    fill: "url(#paint0_linear_30453_14255)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5559 13.1462C19.382 12.1335 18.4139 12.1677 17.6017 12.3617C18.8132 11.9868 19.7828 11.2111 20.4191 10.1361C21.1153 8.95995 19.527 8.79997 18.77 8.84055C19.3941 8.68056 20.2253 8.88112 20.9823 8.84055C21.7394 8.79997 22.4761 8.38089 23.544 7.05832C24.6119 5.73576 23.4764 5.79662 22.9649 5.69749C28.6156 4.88851 25.806 4.40643 25.1684 4.31407C26.9415 4.34557 27.9441 4.1653 29.0188 2.96891C30.0935 1.77251 31.9793 1.54497 31.0623 0.96145C28.4577 -0.417353 23.9915 0.454683 22.0839 1.06305C13.7792 4.29187 14.8596 11.9521 16.403 14.7797C17.9464 17.6072 18.1932 15.8229 18.77 14.7797C19.3467 13.7365 18.5965 13.9033 18.2315 14.1759C17.8665 14.4485 17.3686 14.6017 18.5559 13.1462Z",
    fill: "url(#paint1_linear_30453_14255)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0943 18.3091C19.9953 18.8758 19.8711 18.0967 19.6332 17.4595C20.0571 18.4014 20.7809 19.1077 21.7133 19.5148C22.7334 19.9602 22.3473 17.2068 22.239 16.5989C22.4306 17.0874 22.7084 19.233 22.8167 19.8409C22.925 20.4487 23.3372 21.0024 24.5128 21.7337C25.6884 22.465 25.5259 21.5532 25.555 21.1299C26.7726 25.6167 26.882 23.2976 26.8931 22.773C27.0445 24.2094 27.2902 25.0018 28.3645 25.7511C29.4387 26.5004 29.8108 28.0021 30.191 27.2026C31.0457 24.9598 29.8952 21.4366 29.2132 19.9554C25.7749 13.5648 20.0333 13.0199 17.9017 14.5495C15.7702 16.0791 16.8946 18.2829 17.7953 18.6451C18.696 19.0072 18.4864 18.4174 18.2296 18.1496C17.9729 17.8817 17.7994 17.4945 19.0943 18.3091Z",
    fill: "url(#paint2_linear_30453_14255)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1335 14.9985C13.3075 13.9858 14.2755 14.02 15.0878 14.214C13.8762 13.8391 12.9067 13.0634 12.2704 11.9884C11.5742 10.8122 12.4154 10.7646 13.1724 10.8052C12.5483 10.6452 12.4641 10.7334 11.7071 10.6928C10.9501 10.6523 10.2134 10.2332 9.14545 8.91062C8.07754 7.58805 9.21307 7.64891 9.72452 7.54979C4.07389 6.74081 6.88345 6.25872 7.52107 6.16636C5.74792 6.19787 4.74532 6.0176 3.67064 4.8212C2.59597 3.62481 0.710165 3.39726 1.62717 2.81374C4.23173 1.43494 8.69799 2.30698 10.6056 2.91535C18.9102 6.14416 17.8298 13.8044 16.2864 16.632C14.743 19.4595 14.4962 17.6752 13.9195 16.632C13.3427 15.5888 14.093 15.7556 14.458 16.0282C14.8229 16.3008 15.3209 16.454 14.1335 14.9985Z",
    fill: "url(#paint3_linear_30453_14255)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_iii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.078 19.0662C14.2905 19.7822 14.2761 18.9934 14.3985 18.3244C14.1464 19.3261 13.5578 20.1484 12.7112 20.7127C11.785 21.3302 11.6821 18.5517 11.6821 17.9343C11.5792 18.4488 11.6821 20.6098 11.6821 21.2273C11.6821 21.8447 11.3734 22.4621 10.3443 23.3883C9.31528 24.3144 9.31528 23.3883 9.21238 22.9767C8.80075 27.6075 8.28622 25.3435 8.18331 24.829C8.28622 26.2697 8.18331 27.0929 7.25716 28.0191C6.331 28.9452 6.22814 30.4888 5.71361 29.7685C4.47873 27.7104 4.99326 24.04 5.40489 22.4621C7.66883 15.5674 13.2258 14.0238 15.5926 15.1558C17.9595 16.2878 17.2391 18.6546 16.4159 19.1691C15.5926 19.6837 15.6955 19.0662 15.9013 18.7575C16.1072 18.4488 16.21 18.0372 15.078 19.0662Z",
    fill: "url(#paint4_linear_30453_14255)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8704 37.2466C19.9106 37.2351 19.9014 37.1677 19.9457 37.1469C19.9901 37.1261 20.0144 37.1483 20.0555 37.1105C20.0968 37.0727 20.1545 37.0589 20.1672 37.034C20.1782 37.0125 20.1981 37.0322 20.2182 37.0215C20.2217 37.0196 20.2252 37.0168 20.2286 37.0129C20.2523 36.9857 20.2726 36.9778 20.3051 36.9711C20.3378 36.9642 20.4208 36.9199 20.4409 36.8875C20.4456 36.8799 20.4526 36.8738 20.4603 36.8694C20.4854 36.8552 20.5176 36.8581 20.5358 36.854C20.5432 36.8524 20.5496 36.8522 20.5549 36.8527C20.5571 36.8529 20.5591 36.8547 20.5603 36.857C20.5603 36.857 20.5603 36.857 20.5603 36.857C20.5618 36.8598 20.562 36.8632 20.5601 36.8646C20.5508 36.8718 20.5377 36.8845 20.5254 36.9043C20.5148 36.9212 20.5066 36.9263 20.4968 36.9305C20.4858 36.9351 20.4722 36.939 20.4525 36.9597C20.4161 36.998 20.4035 37.0336 20.3453 37.0567C20.3106 37.0704 20.3047 37.0962 20.2863 37.1194C20.2743 37.1348 20.2563 37.1492 20.2202 37.1579C20.1305 37.1796 20.1592 37.2357 20.0938 37.2918C20.0286 37.3479 19.9202 37.382 19.8794 37.4139C19.8386 37.4458 19.7857 37.4915 19.7204 37.5263C19.6551 37.5611 19.5915 37.6293 19.5142 37.6616C19.5117 37.6627 19.5092 37.6637 19.5067 37.6647C19.4301 37.6974 19.324 37.7375 19.2702 37.7476C19.2149 37.7581 19.2028 37.7603 19.1528 37.7808C19.1238 37.7924 19.0791 37.7929 19.0448 37.7769C19.0275 37.7689 19.0317 37.7577 19.0485 37.7522C19.0728 37.744 19.0929 37.7473 19.1031 37.7318C19.1231 37.7006 19.1273 37.6889 19.1596 37.6967C19.1929 37.7036 19.1934 37.6631 19.2105 37.6606C19.2277 37.6571 19.2377 37.6799 19.3116 37.6206C19.3609 37.58 19.3949 37.5515 19.4209 37.5306C19.4333 37.5205 19.4441 37.5118 19.4533 37.5042C19.4814 37.4811 19.5548 37.4549 19.6003 37.4155C19.6455 37.3765 19.7487 37.3126 19.7824 37.2753C19.816 37.2381 19.8301 37.2581 19.8704 37.2466Z",
    fill: "#953D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2647 28.6164C20.2713 28.6151 20.2764 28.6116 20.2803 28.6068C20.297 28.5864 20.2945 28.542 20.3246 28.5295C20.3619 28.5139 20.3852 28.5367 20.4184 28.5037C20.432 28.4902 20.4488 28.4803 20.4648 28.472C20.4876 28.4606 20.507 28.4522 20.512 28.439C20.5202 28.4166 20.5458 28.4474 20.5632 28.423C20.5803 28.3985 20.5966 28.392 20.624 28.3857C20.6515 28.3802 20.7163 28.334 20.7207 28.3022C20.7214 28.2977 20.7229 28.2936 20.7248 28.2901C20.7381 28.2676 20.7712 28.2605 20.7863 28.2513C20.7918 28.248 20.7971 28.2461 20.8017 28.2451C20.8037 28.2447 20.8061 28.2458 20.808 28.2475C20.808 28.2475 20.808 28.2475 20.808 28.2475C20.8105 28.2495 20.8121 28.2524 20.8111 28.2542C20.8063 28.2629 20.8007 28.2774 20.7986 28.2979C20.7964 28.3199 20.7888 28.3251 20.7791 28.3334C20.7716 28.34 20.763 28.3481 20.7532 28.3656C20.7301 28.4062 20.7239 28.4419 20.6739 28.4656C20.6243 28.4878 20.6507 28.5432 20.5699 28.5598C20.5546 28.5627 20.5434 28.5669 20.5347 28.5722C20.5002 28.594 20.5126 28.6378 20.4676 28.678C20.4398 28.7028 20.4019 28.7209 20.3666 28.7359C20.3312 28.7509 20.2981 28.763 20.2804 28.7761C20.2451 28.8024 20.199 28.8403 20.1412 28.8658C20.0844 28.8908 20.0284 28.9467 19.9603 28.9672C19.9593 28.9675 19.9583 28.9678 19.9574 28.9681C19.8884 28.9882 19.7912 29.0117 19.7449 29.0171C19.6986 29.0227 19.6876 29.0239 19.6502 29.0462C19.6436 29.0501 19.6357 29.0536 19.6273 29.0563C19.6084 29.0626 19.5856 29.0652 19.5637 29.0622C19.5484 29.0603 19.5447 29.0492 19.5575 29.0381C19.5747 29.0228 19.5928 29.0217 19.5981 29.0047C19.5998 28.9995 19.6012 28.9948 19.6028 28.9905C19.6109 28.9671 19.6184 28.9584 19.6447 28.9632C19.6758 28.9687 19.674 28.9294 19.6899 28.9276C19.7057 28.9255 19.7147 28.9466 19.7805 28.8987C19.8293 28.8626 19.8613 28.8398 19.8847 28.8233C19.8925 28.8179 19.8993 28.813 19.9054 28.8086C19.9296 28.7911 19.9937 28.7767 20.0327 28.7453C20.0716 28.7143 20.1603 28.666 20.1883 28.6343C20.2162 28.6027 20.2296 28.6232 20.2647 28.6164Z",
    fill: "#953D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3335 22.0193V22.1226",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.617438,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7691 24.069L19.7656 24.0647",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.617438,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2266 29.9586C21.2262 29.9586 21.2258 29.9586 21.2091 29.9733C21.1923 29.9879 21.1591 30.0173 21.1216 30.0522",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.617438,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3394 33.3369C22.3394 33.3373 22.3394 33.3376 22.3413 33.3426C22.3432 33.3476 22.3471 33.3573 22.3533 33.3694",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.411625,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3672 35.6733V35.6751",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.411625,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8745 34.9333V34.9413",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.205813,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0852 31.3665L21.0825 31.3675",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.205813,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7965 24.5804C20.7958 24.5804 20.7951 24.5804 20.7943 24.5859C20.7935 24.5914 20.7928 24.6023 20.792 24.6136",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.205813,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9351 20.7871L18.9419 20.8031",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.205813,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3042 38.5294V38.5449",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.205813,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6558 41.7864L21.6426 41.7971",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.205813,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8984 43.5837V43.5976",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.411625,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6846 43.7406C21.6849 43.7406 21.6853 43.7406 21.6865 43.7352C21.6878 43.7298 21.6899 43.719 21.692 43.7079",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.411625,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1484 40.2208L22.1465 40.217",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.411625,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8595 39.2686C19.858 39.2692 19.8566 39.2698 19.8535 39.2753C19.8504 39.2807 19.8457 39.291 19.8408 39.3194",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.411625,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1167 36.5194V36.5438",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.617438,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0923 42.165H19.4656",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.617438,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2822 32.6866L20.3083 32.6855",
    stroke: "#D07F49",
    strokeOpacity: 0.7,
    strokeWidth: 0.617438,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_30453_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3003 15.649C20.3415 15.4283 19.7099 14.9557 19.0954 14.6641C20.0556 15.0448 21.0668 15.0477 22.0195 14.6905C23.0618 14.2997 21.4941 13.5349 20.9931 13.1741C21.4707 13.3913 22.5373 13.7952 23.0384 14.156C23.5395 14.5168 24.2209 14.6271 25.5738 14.3332C26.9267 14.0393 26.1751 13.4981 25.9012 13.1741C29.8997 15.5461 28.3631 13.8056 28.0057 13.4214C29.1147 14.3468 29.8429 14.7443 31.1357 14.534C32.4285 14.3236 33.7412 15.1421 33.4573 14.3036C32.5087 12.0989 29.2296 10.3717 27.7086 9.78365C20.7906 7.59192 16.2908 11.1994 15.8263 13.7816C15.3618 16.3637 17.7035 17.1622 18.6021 16.7948C19.5007 16.4274 18.9395 16.1501 18.5687 16.1367C18.1979 16.1234 17.8038 15.9663 19.3003 15.649Z",
    fill: "url(#paint5_linear_30453_14255)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_30453_14255",
    x: 16.2114,
    y: 16.4297,
    width: 7.53662,
    height: 30.2844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.44069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.531832 0 0 0 0 0.246246 0 0 0 0 0.164649 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.617438,
    dy: 0.205813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.390306 0 0 0 0 0.190674 0 0 0 0 0.0831804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_30453_14255",
    x: 0.674316,
    y: 10.6245,
    width: 17.4951,
    height: 7.37427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.205813,
    dy: -2.05813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.31631 0 0 0 0 0.516977 0 0 0 0 0.119429 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.763374 0 0 0 0 0.85006 0 0 0 0 0.382709 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_30453_14255",
    x: 15.332,
    y: 0.226074,
    width: 15.9741,
    height: 16.0756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.205813,
    dy: -0.617438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360784 0 0 0 0 0.568627 0 0 0 0 0.156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.763374 0 0 0 0 0.85006 0 0 0 0 0.382709 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_30453_14255",
    x: 16.6812,
    y: 13.8341,
    width: 13.8135,
    height: 13.5964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.411625,
    dy: -1.6465
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.193808 0 0 0 0 0.474835 0 0 0 0 0.0508293 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.205813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.763374 0 0 0 0 0.85006 0 0 0 0 0.382709 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_30453_14255",
    x: 1.3833,
    y: 2.07837,
    width: 15.9741,
    height: 16.0756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279964 0 0 0 0 0.546612 0 0 0 0 0.144301 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.763374 0 0 0 0 0.85006 0 0 0 0 0.382709 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_iii_30453_14255",
    x: 4.93945,
    y: 14.8186,
    width: 12.2612,
    height: 15.1356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.205813,
    dy: -2.05813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360784 0 0 0 0 0.568627 0 0 0 0 0.156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.415686 0 0 0 0 0.0784314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.763374 0 0 0 0 0.85006 0 0 0 0 0.382709 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_30453_14255",
    result: "effect3_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_30453_14255",
    x: 15.7661,
    y: 9.10632,
    width: 17.7305,
    height: 7.77307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.205813,
    dy: -2.05813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360784 0 0 0 0 0.568627 0 0 0 0 0.156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_30453_14255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.823251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.763374 0 0 0 0 0.85006 0 0 0 0 0.382709 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_30453_14255",
    result: "effect2_innerShadow_30453_14255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30453_14255",
    x1: 4.84228,
    y1: 14.6165,
    x2: 18.8292,
    y2: 15.5709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F601E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30453_14255",
    x1: 24.9023,
    y1: 2.36421,
    x2: 14.5026,
    y2: 16.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F601E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30453_14255",
    x1: 28.4426,
    y1: 22.3634,
    x2: 16.3177,
    y2: 15.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F601E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30453_14255",
    x1: 7.78715,
    y1: 4.21651,
    x2: 18.1869,
    y2: 17.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F601E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30453_14255",
    x1: 6.58595,
    y1: 24.6976,
    x2: 17.2882,
    y2: 15.6419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F601E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_30453_14255",
    x1: 28.8325,
    y1: 12.0484,
    x2: 15.2299,
    y2: 15.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CC63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F601E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndersenSummerLogo);
export default __webpack_public_path__ + "static/media/andersenSummerLogo.ef5ccda3bc81c9c5ca9c03ec14b44116.svg";
export { ForwardRef as ReactComponent };